<template>
  <div class="supply-main-filter">
    <sub-header
      title="Pedidos de insumos"
      class="alternative-subheader"
      :centralized="true"
      :back-button-visible="true"
    />

    <div class="supply-main-filter__container">
      <div class="cards-filter-container__tabs">
        <div
          id="filterTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': tabSelected }"
          @click="changeTab(true)"
        >
          Filtrar
        </div>
      </div>

      <div class="cards-filter-container__filter">
        <div class="cards-filter-container__filter-field-area">
          <md-checkbox
            id="chkboxExported"
            v-model="principalFilter.requested"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Solicitado
          </md-checkbox>
          <md-checkbox
            id="chkboxNotExported"
            v-model="principalFilter.analysis"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Em análise
          </md-checkbox>
          <md-checkbox
            id="chkboxExported"
            v-model="principalFilter.attendance"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Em atendimento
          </md-checkbox>
          <md-checkbox
            id="chkboxExported"
            v-model="principalFilter.logistics"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Entregue à logística
          </md-checkbox>
          <md-checkbox
            id="chkboxExported"
            v-model="principalFilter.finished"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Finalizado
          </md-checkbox>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <!-- <md-checkbox
            v-model="principalFilter.pendency"
            mdValue="false"
            class="cards-filter-container__filter-checkbox"
            id="chkboxNotIntegrated"
          >Atendido com Pendência</md-checkbox> -->
          <md-checkbox
            id="chkboxIntegrated"
            v-model="principalFilter.partially"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Atendido Parcialmente
          </md-checkbox>
          <md-checkbox
            id="chkboxIntegrated"
            v-model="principalFilter.partially_pendency"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Atendido Parcialmente com Pendência
          </md-checkbox>
          <md-checkbox
            id="chkboxIntegrated"
            v-model="principalFilter.totally"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Atendido Totalmente
          </md-checkbox>
          <md-checkbox
            id="chkboxIntegrated"
            v-model="principalFilter.refused"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Negado por Operações
          </md-checkbox>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <div class="date-range-container">
            <p class="date-range-container-label">
              Período
            </p>
            <date-picker-range
              :date-selected.sync="date"
              :date-filter-alternative="true"
              :calendar-direction="'bottom'"
              :clear-button="false"
              :max-date="null"
              :default-start-date="date.start"
              :default-end-date="date.end"
              @update:dateSelected="setFiltersGlobally"
            />
          </div>
        </div>
        <div class="cards-filter-container__filter-container-button">
          <md-button
            class="btn btn-primary cards-filter-container__filter-button cards-filter-container__filter-button-right"
            @click="submitSearch('filter')"
          >
            Filtrar pedidos
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeader'
import DatePickerRange from '../common/DatePickerRange'
import SupplyService from '@/api/supply'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SupplyMainFilter',
  components: {
    'sub-header': SubHeader,
    'date-picker-range': DatePickerRange
  },
  data: () => ({
    tabSelected: true,
    situationsFilter: [],
    principalFilter: {
      requested: true,
      analysis: false,
      canceled: false,
      logistics: false,
      finished: true,
      // pendency: true,
      partially: false,
      partially_pendency: false,
      totally: false,
      refused: true,
      attendance: false
    },
    date: {
      start: new Date(),
      end: new Date()
    },
    hasTime: false,
    query: '/gestao-de-insumos?'
  }),
  methods: {
    ...mapActions(['exportResultByFilter']),
    ...mapActions(['updateResultFilters']),
    ...mapActions(['updateResultsStatistics']),
    ...mapActions(['resetResultsStatistics']),
    ...mapActions(['selectResultList']),
    changeTab (value) {
      this.tabSelected = value
    },
    createQuery (value) {
      let status = this.setStatusValue()
      let situations = this.setSituationValue()

      if (this.date.start && this.date.end) {
        this.query = this.query.concat(
          '&startDate=' +
            Moment(this.date.start).format('YYYY-MM-DD hh:mm:ss') +
            '&endDate=' +
            Moment(this.date.end).format('YYYY-MM-DD hh:mm:ss')
        )
      }
      switch (value) {
        case 'filter':
          if (situations) {
            this.query = this.query.concat('&situations=' + situations)
          }
          if (status) {
            this.query = this.query.concat('&status=' + status)
          }
          break
      }
    },
    setStatusValue () {
      const value = []
      if (this.principalFilter.requested) {
        value.push('SOLICITADO')
      }
      if (this.principalFilter.canceled) {
        value.push('CANCELADO')
      }
      if (this.principalFilter.analysis) {
        value.push('EM ANÁLISE')
      }
      if (this.principalFilter.logistics) {
        value.push('ENTREGUE À LOGÍSTICA')
      }
      if (this.principalFilter.finished) {
        value.push('FINALIZADO')
      }
      if (this.principalFilter.attendance) {
        value.push('EM ATENDIMENTO')
      }
      return value.join(',')
    },
    setSituationValue () {
      const value = []
      // if (this.principalFilter.pendency) {
      //   value.push('Atendido com Pendência')
      // }
      if (this.principalFilter.partially) {
        value.push('Atendido Parcialmente')
      }
      if (this.principalFilter.partially_pendency) {
        value.push('Atendido Parcialmente com Pendência')
      }
      if (this.principalFilter.totally) {
        value.push('Atendido Totalmente')
      }
      if (this.principalFilter.refused) {
        value.push('Negado por Operações')
      }
      return value.join(',')
    },
    submitSearch (value) {
      this.createQuery(value)
      this.setFiltersGlobally()
      this.$router.push({ path: this.query })
    },
    getFiltersGlobally () {
      if ( Object.keys(this.getResultFilters.principalFilter).length > 0 ) {
        this.principalFilter = this.getResultFilters.principalFilter
        this.date = this.getResultFilters.date
      }
    },
    setFiltersGlobally () {
      let filterArray = {}
      filterArray.principalFilter = this.principalFilter
      filterArray.date = this.date
      this.updateResultFilters(filterArray)
    },
    setFilterStatus () {
      SupplyService.getSupplyRequestStatus()
        .then((response) =>{
          console.log(response, 'teste')
        })
    },
    setFilterSituation () {
      SupplyService.getSupplyRequestSituation()
        .then((response) =>{
          this.situationsFilter = response
          console.log(response, 'teste')
        })
    }
  },
  computed: {
    ...mapGetters(['getResultFilters']),
    ...mapGetters(['getResultStatistictsLoadingStatus']),
    ...mapGetters(['getResultStatistics']),
    ...mapGetters(['profile']),
    defaultStartDate () {
      if (this.$route.query.startDate) {
        return Moment(this.$route.query.startDate).toDate()
      } else {
        return new Date()
      }
    },
    defaultEndDate () {
      if (this.$route.query.endDate) {
        return Moment(this.$route.query.endDate).toDate()
      } else {
        return new Date()
      }
    }
  },
  created () {
    this.getFiltersGlobally()
    this.setFilterStatus()
    this.setFilterSituation()
    
    this.$analytics.pushAnalyticsEvent('vpageview', {
      page: 'results/filter',
      'id-usuario': this.profile.id,
      'id-lab': this.profile.id_laboratory,
      nlab: this.profile.laboratoryName
    })
  },
  beforeDestroy () {
    this.query = '/gestao-de-insumos?'
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";

.supply-main-filter {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: 150px;
  font-family: 'Exo 2', sans-serif;

  &__container {
    flex-flow: column wrap;
    display: block;
    min-width: 670px;
  }

  &__title {
    height: 26px;
    line-height: 26px;
    text-align: left;
    color: #7a7a7a;
    font-weight: 500;
    letter-spacing: 0.8px;
    margin-left: 1em;
    font-size: 14px;
  }
  .cards-filter-container {
    display: flex;

    &__tabs {
      display: flex;
      margin-top: 10px;
      margin-left: 15px;

      &-single {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding: 10px 40px 10px 40px;
        background-color: rgba(255, 255, 255, 0.5);
        margin-right: 3px;
        cursor: pointer;
        line-height: 26px;
        text-align: left;
        color: #7a7a7a;
        font-weight: 500;
        letter-spacing: 0.8px;
        font-size: 14px;
      }

      &-selected {
        background-color: white;
      }
    }

    &__filter {
      background-color: white;
      border-radius: 5px;
      border-top-left-radius: 0px;
      margin-left: 15px;
      padding: 15px;
      max-width: 678px;

      &-field-area {
        background-color: rgba(127, 26, 84, 0.1);
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 10px 20px;
      }

      &-container-button {
        display: flex;
        justify-content: flex-end;
      }

      &-button {
        padding: 0 30px;
      }

      .btn-nonenary {
        .md-icon {
          > svg .color {
            fill: $brand-primary;
            transition: 0.6s;
          }
        }

        &:hover .md-icon > svg .color {
          fill: white;
          transition: 0.6s;
        }
      }

      .md-input-container {
        background-color: white;
        border-radius: 5px;
        min-height: auto;
        margin: 0px;
        padding-top: 0px;
        padding-right: 10px;
      }

      .input-layout-container,
      .date-range-container {
        display: flex;
        align-items: center;

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-right: 10px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
      }
      .date-range-container {
        padding-top: 15px;
        padding-bottom: 15px;

        .search-bar__date {
          margin: 0;
          .md-input-container,
          .md-input {
            height: 36px;
          }
          .md-icon {
            margin: 6px auto;
          }
        }

        .md-input-container input,
        .md-input-container textarea {
          min-width: 240px;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .date-range-container,
      .input-layout-container {
        padding-top: 0;
        padding-bottom: 0;

        &-label {
          justify-content: right;
          display: flex;
          white-space: normal;
          text-align: right;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .date-range-container {
        .md-input-container {
          max-width: 100%;

          &::after {
            display: none;
          }
        }
      }

      .input-layout-container {
        .md-input-container {
          max-width: 80%;
          max-height: 2.3em;
          align-self: center;

          &::after {
            display: none;
          }
        }
      }

      .md-checkbox {
        margin-right: 2em;
        margin-top: 6px;
        margin-bottom: 6px;

        .md-checkbox-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 3px;
        }
      }

      .md-theme-default.md-checkbox.md-checked .md-checkbox-container {
        background-color: $brand-primary;
        border: 2px solid $brand-primary;
      }

      .md-checkbox-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-radio {
        margin-right: 2em;

        .md-radio-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
        }
      }

      .md-theme-default.md-radio.md-checked .md-radio-container {
        background-color: white;
        border: 2px solid white;
      }

      .md-radio-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-theme-default.md-radio .md-radio-container::after {
        background-color: $brand-primary;
      }
    }
  }
}
</style>
